import React from 'react';

import { UserCircleIcon } from '@ergeon/icons/hero/micro';

import { EmailSuggestion } from '../types';

type SuggestionItemProps = {
  suggestion: EmailSuggestion;
  isSelected: boolean;
  onSelect: (email: string) => void;
};

const SuggestionItem: React.FC<SuggestionItemProps> = ({ suggestion, isSelected, onSelect }) => {
  const baseClasses = 'flex items-start gap-2 p-4 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700';
  const selectedClasses = isSelected ? 'bg-gray-100 dark:bg-gray-700' : '';

  return (
    <div className={`${baseClasses} ${selectedClasses}`} onClick={() => onSelect(suggestion.email)}>
      <UserCircleIcon className="size-5 shrink-0 text-gray-400 dark:text-gray-600" />
      <div className="flex flex-col gap-0.5 w-full min-w-0">
        {suggestion.name && (
          <p className="text-gray-900 dark:text-white truncate paragraph-2">{suggestion.name}</p>
        )}
        <p className="text-gray-500 dark:text-gray-400 truncate paragraph-2">{suggestion.email}</p>
      </div>
    </div>
  );
};

export default SuggestionItem;
